var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagerArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.095,
    height: 12.69,
    viewBox: "0 0 7.095 12.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38025",
    "data-name": "Path 38025",
    d: "M18,7.5l5.815,5.815L18,19.129",
    transform: "translate(-17.47 -6.97)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagerArrow);
export default __webpack_public_path__ + "static/media/pager-arrow.51e948b648fc68ad980b536aecdb9102.svg";
export { ForwardRef as ReactComponent };